commusoftCommon.directive('ng7RouteLink',
    ['HybridFactory', '$state', '$location', function (HybridFactory, $state, $location) {

        return {
            restrict: 'A',
            link: function (scope, element, attrs) {

                element.on('click', function (e) {

                    if (
                        e.ctrlKey ||
                        e.metaKey ||
                        e.shiftKey ||
                        e.which === 2 ||   // middle mouse
                        e.button === 1
                    ) {
                        return; // do NOT preventDefault
                    }

                    // Normal left click only
                    e.preventDefault();

                    var link = element.prop('tagName') === 'A'
                        ? element.attr('href')
                        : attrs.ng7RouteLink;

                    // Safety check
                    if (!link) return;

                    // Existing routing logic
                    if ($state.current.name === 'loggedin.empty') {
                        HybridFactory.redirectNg7Route(link);
                    }
                    else if (element.attr('target')) {
                        window.open(link, element.attr('target'));
                    }
                    else {
                        scope.$apply(function () {
                            $location.path(link);
                        });
                    }
                });

                scope.$on('$destroy', function () {
                    element.off('click');
                });
            }
        };
    }
    ]
);


commusoftCommon.directive('ngJsRouteLink',
    ['$state', function($state) {
        return {
            restrict: 'A',
            scope: {
                goState: '='
            },
            link: function (scope, element) {
                if (!scope.goState || !scope.goState.stateName) return;

                const stateName = scope.goState.stateName;
                const stateParams = scope.goState.params || {};

                const url = $state.href(stateName, stateParams);
                element.attr('href', url);

                element.on('click', function (e) {
                    if (
                        e.ctrlKey ||
                        e.metaKey ||
                        e.shiftKey ||
                        e.which === 2 ||   // middle mouse button
                        e.button === 1
                    ) {
                        return; // DO NOT preventDefault
                    }

                    // Normal left click SPA navigation
                    e.preventDefault();
                    scope.$apply(function () {
                        $state.go(stateName, stateParams);
                    });
                });

                scope.$on('$destroy', function () {
                    element.off('click');
                });
            }
        };
    }]
);
